import React from "react";
import { Link } from "react-router-dom";
import { Fade } from "react-awesome-reveal";

const SubCategoryCard = ({ img, title, id }) => {
  return (
    <Link 
      to={`/products/subCategory/${id}?page=1`} 
      onClick={() => localStorage.setItem('page', 1)}
      title={title} 
      style={{ textDecoration: 'none', display: 'block' }}
    >
      <div className="noon-category-card">
        <Fade>
          <div className="noon-category-img-box">
            <img
              className="noon-category-img"
              src={img}
              alt={title}
              loading="lazy"
            />
          </div>
          <div className="noon-category-text" style={{ fontSize: '13px', fontWeight: 'bold' }}>
            {title}
          </div>
        </Fade>
      </div>
    </Link>
  );
};

export default SubCategoryCard;
